export const DEPARTMENT_VALUE = Object.freeze({
  RECEPTIONIST: 0,
  TICKET: 1
})

export const PROMOTION_TYPE_VALUE = Object.freeze({
  PROMOTION: 0,
  VOUCHER: 1
})

export const PROMOTION_STATUS_VALUE = Object.freeze({
  APPLYING: 0,
  STOP_APPLYING: 1
})

export const VOUCHER_TYPE_VALUE = Object.freeze({
  PERCENT: 0,
  FIXED: 1
})

export const PROMOTION_PCODE = Object.freeze({
  PM_PMS: 'PM_PMS',
  VC_PMS: 'VC_PMS',
  PM_TICKET: 'PM_TICKET',
  VC_TICKET: 'VC_TICKET',

  PM_APPLY_PMS: 'PM_APPLY_PMS',
  VC_APPLY_PMS: 'VC_APPLY_PMS',
  PM_APPLY_TICKET: 'PM_APPLY_TICKET',
  VC_APPLY_TICKET: 'VC_APPLY_TICKET'
})

export const PROMOTION_CONDITION_CODE = Object.freeze({
  // booking pms
  arriveMoreThenTwo: 'PM_PMS_01',
  inSpecificSource: 'PM_PMS_02',
  birthday: 'PM_PMS_03',

  bookingUseVoucher: 'VC_PMS_01',

  // ticket
  ticketType: 'PM_TICKET_01',
  ticketQuantity: 'PM_TICKET_02',
  ticketKid: 'PM_TICKET_03',

  ticketValid: 'VC_TICKET_01',
  ticketCauKinh: 'VC_TICKET_02',
  ticketAirSlide: 'VC_TICKET_03',
  ticketPlay: 'VC_TICKET_04'
})

export const PROMOTION_APPLY_CODE = Object.freeze({
  // booking pms
  roomCharge: 'PM_APPLY_PMS_01',
  food: 'PM_APPLY_PMS_02',
  comboTicket: 'PM_APPLY_PMS_03',
  cauKinh: 'PM_APPLY_PMS_04',
  cauKinhAndFood: 'PM_APPLY_PMS_05',
  comboTicketAndFood: 'PM_APPLY_PMS_06',

  bookingUseVoucher: 'VC_APPLY_PMS_01',

  // ticket
  decreaseTicketTypePercentage: 'PM_APPLY_TICKET_01',
  freeSomeTicket: 'PM_APPLY_TICKET_02',
  decreaseTicketPrice: 'PM_APPLY_TICKET_03',

  decreaseBill: 'VC_APPLY_TICKET_01',
  voucherFreeSomeTicket: 'VC_APPLY_TICKET_02'
})
